import OWNERTYPES from './ownerTypes';

export default class OwnerTypeFactory {
  static createInstance(type) {
    const ownerTypeCreator = OWNERTYPES[type];
    const ownerType = ownerTypeCreator ? new ownerTypeCreator() : null;

    return ownerType;
  }
}
